import { Component, OnInit, Input } from '@angular/core';
import { RenewalStatus } from '../../../_common/_enum/module.enum';
import { Renewal } from '../../_models/start-renewal';
import { RenewalsService } from '../../_services/renewals.service';

@Component({
  selector: 'app-online-activity',
  templateUrl: './online-activity.component.html',
  styleUrls: ['./online-activity.component.scss']
})
export class OnlineActivityComponent implements OnInit {
  @Input() onlineActivities: any;
  @Input() renewalStatus;
  
  private diceRenewalStatusEnum = RenewalStatus;
  
  // Below variable is temporary for testing purpose only
  private _activitiesList = [
    {
      activityDate: "2021-05-11T18:48:40.507Z",
      activityId: "1",
      activityName: "Renewal Period Opened",
      doneBy: "ProSight"
    },
    {
      activityDate: "2021-05-11T18:48:40.507Z",
      activityId: "1",
      activityName: "Renewal In Progress",
      doneBy: "ProSight"
    },
    {
      activityDate: "2021-05-11T18:48:40.507Z",
      activityId: "1",
      activityName: "Renewal submitted",
      doneBy: "ProSight"
    },
    {
      activityDate: "2021-05-11T18:48:40.507Z",
      activityId: "1",
      activityName: "Renewal Period Cancelled",
      doneBy: "ProSight"
    },
    {
      activityDate: "2021-05-11T18:48:40.507Z",
      activityId: "1",
      activityName: "Renewal In Progress",
      doneBy: "ProSight"
    },
    {
      activityDate: "2021-05-11T18:48:40.507Z",
      activityId: "1",
      activityName: "Renewal submitted",
      doneBy: "ProSight"
    },
    {
      activityDate: "2021-05-11T18:48:40.507Z",
      activityId: "1",
      activityName: "Renewal Period Cancelled",
      doneBy: "ProSight"
    }
  ]

  constructor(private renewalsService: RenewalsService) { }

  ngOnInit() {
    console.log('onlineActivities :: ', this.onlineActivities);
    console.log('renewalStatus :: ', this.renewalStatus);
  }

  downloadDocuments(_docObj, docName) {
    /* _docObj.accountNumber = 10096620; // this.renewalDetails.accountNumber
    _docObj.id = 6664241; */

    _docObj.isDownloading = true;

    let documentDownloadSubscription = this.renewalsService.downloadDocuments(_docObj.accountNumber, _docObj.documentId, docName).subscribe(response => {
      _docObj.isDownloading = false;
    },
    error => {
      _docObj.isDownloading = false;
      this.renewalsService.openModal('error', 'none');
    });
    this.renewalsService.runningServices.push(documentDownloadSubscription);
  }

}
